// extracted by mini-css-extract-plugin
export default {"error_title":"style_error_title__ChSX2","error_title_x2":"style_error_title_x2__4VMnz","error_message":"style_error_message__B4kFK"};